import { render, staticRenderFns } from "./MapSettings.vue?vue&type=template&id=63c8b020"
import script from "./MapSettings.vue?vue&type=script&lang=ts"
export * from "./MapSettings.vue?vue&type=script&lang=ts"
import style0 from "./MapSettings.vue?vue&type=style&index=0&id=63c8b020&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports